import * as Yup from 'yup';

export const getCustomFieldValue = ({ type, multiple, value }) =>
    value?.[`${type}${multiple ? 's' : ''}`] ?? null;

export const getCustomField = (customFields, id, onValueModification) => {
    const customField = customFields?.find(({ id: customFieldId }) => customFieldId === id);
    const handleValueModification = onValueModification ? onValueModification : data => data;

    return {
        ...(customField ?? {}),
        value: handleValueModification(
            getCustomFieldValue(customFields?.find(({ id: customFieldId }) => customFieldId === id))
        ),
        exists: !!customField,
    };
};

export const getCustomFieldsSubmitValues = (values, customFields) => {
    return Object.keys(values)?.map(customFieldId => {
        const customField = customFields?.find(({ id }) => id === customFieldId);

        return {
            _id: customField?._id,
            value:
                customField?.type === 'collection'
                    ? Object.keys(values?.[customFieldId])?.map(collectionCustomFieldId => {
                          const collectionCustomField = customField?.items?.find(
                              ({ id }) => id === collectionCustomFieldId
                          );

                          return {
                              _id: collectionCustomField?._id,
                              value: values?.[customFieldId]?.[collectionCustomFieldId],
                          };
                      })
                    : values?.[customFieldId] || undefined,
        };
    });
};

export const getCustomFieldsInitialValues = customFields => {
    if (!customFields) return {};
    const fields = {};

    customFields?.forEach(({ value, type, id }) => {
        if (type === 'collection') {
            const collectionFields = {};

            value?.forEach(({ value, type, id }) => {
                collectionFields[id] = value;
            });

            fields[id] = collectionFields;
            return;
        }

        fields[id] = value;
    });

    return fields;
};

export const getCustomFieldsValidation = customFields => {
    if (!customFields) return Yup.object().shape({});

    const schema = {};

    Object.keys(customFields).forEach(key => {
        schema[customFields[key].id] = getCustomFieldValidation(customFields[key]);
    });

    return Yup.object().shape(schema);
};

const getCustomFieldValidation = ({ type, label, optional, validation, multiple, items }) => {
    let value;

    switch (type) {
        case 'string':
            value = Yup.string();
            if (multiple) value = Yup.array().of(Yup.string());
            if (validation?.type === 'text' && validation?.condition === 'email') {
                if (multiple) {
                    value = Yup.array().of(
                        Yup.string().email(validation?.error ?? 'Must be an email address.')
                    );
                } else {
                    value = value.email(validation?.error ?? 'Must be an email address.');
                }
            }
            if (!optional) value = value.required(`${label} is required.`);
            return value;
        case 'html':
        case 'paragraph':
        case 'dropdown':
        case 'image':
            value = Yup.string();
            if (multiple) value = Yup.array().of(Yup.string());
            if (!optional) value = value.required(`${label} is required.`);
            return value;
        case 'radio':
            value = Yup.string();
            if (!optional) value = value.required(`${label} is required.`);
            return value;
        case 'checkbox':
            value = Yup.array().of(Yup.string());
            if (!optional) value = value.required(`${label} is required.`);
            return value;
        case 'collection':
            const schema = {};

            Object.keys(items).forEach(key => {
                schema[items[key]?.id] = getCustomFieldValidation(items[key]);
            });

            value = Yup.object().shape(schema);
            if (!optional) value = value.required(`${label} is required.`);

            return value;
    }

    return Yup.mixed().nullable();
};
